var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4566 36.0957V23.7297H15.7066L22.2226 32.4237V23.7297H24.4726V36.0957H22.2226L15.7066 27.4017V36.0957H13.4566ZM26.2298 37.4277L32.4578 22.7217H34.8158L28.5878 37.4277H26.2298ZM44.0744 36.0957L43.1024 33.7557H37.1984L36.2264 36.0957H33.7244L38.9084 23.7297H41.3924L46.5764 36.0957H44.0744ZM37.9724 31.9197H42.3284L40.1504 26.6997L37.9724 31.9197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaIcon);
export default __webpack_public_path__ + "static/media/na_icon.d87261d7772e6771c4487ece71a29a0d.svg";
export { ForwardRef as ReactComponent };